import debounce from 'debounce';
import { useEffect, useState } from 'react';

export const useContainerWidth = <T extends HTMLElement>(
	ref: React.RefObject<T | null>,
	throttle = 0
) => {
	const [width, setWidth] = useState<number>(0);

	useEffect(() => {
		if (ref.current) {
			setWidth(ref.current.getBoundingClientRect().width);
		}

		const handleResize = throttle
			? debounce(() => {
					if (ref.current) {
						setWidth(ref.current.getBoundingClientRect().width);
					}
			  }, throttle)
			: () => {
					if (ref.current) {
						setWidth(ref.current.getBoundingClientRect().width);
					}
			  };

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, [ref, throttle]);

	return width;
};
